export class HolidayRequestTypeModel{
  id: number;
  name: string;
  isBillable: boolean;
}
